const hiddenClass = 'selling_plan_theme_integration--hidden';

class SellingPlansWidget {
  constructor(sellingPlansWidgetContainer) {
    this.sellingPlansWidgetContainer = sellingPlansWidgetContainer;
    this.isPreview = sellingPlansWidgetContainer.dataset.uxPreview === 'true';

    if (!this.isPreview) {
      this.enablePerformanceObserver();
    }

    if (!this.isPreview) {
      this.appendSellingPlanInputs();
    }

    this.updateSellingPlanInputsValues();
    this.listenToVariantChange();
    this.listenToSellingPlanFormRadioButtonChange();
    this.updatePrice();

    const selects = this.sellingPlanSelect;
    if (selects.length) {
      selects.forEach((selectItem) => {
        selectItem.addEventListener('change', (e) => {
          const target = document.getElementById(e.target.value);
          if (target) target.click();
        });
        selectItem.addEventListener('blur', (e) => {
          const target = document.getElementById(e.target.value);
          if (target) target.click();
        });
      });
    }
  }

  get sectionId() {
    return this.sellingPlansWidgetContainer.getAttribute('data-section-id');
  }

  get shopifySection() {
    return document.querySelector(`#shopify-section-${this.sectionId}`);
  }

  get variantIdInput() {
    if (this.isPreview) {
      return this.sellingPlansWidgetContainer.querySelector('.selling-plans-ux-lab-variant-id');
    }

    return (
      this.addToCartForms[1]?.querySelector(`input[name="id"]`) ||
      this.addToCartForms[1]?.querySelector(`select[name="id"]`) ||
      this.addToCartForms[0]?.querySelector(`input[name="id"]`) ||
      this.addToCartForms[0]?.querySelector(`select[name="id"]`)
    );
  }

  get sellingPlanSelect() {
    return this.sellingPlansWidgetContainer.querySelectorAll(
      '.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) .selling-plan-select',
    );
  }

  get sellingPlanRecurring() {
    return this.sellingPlansWidgetContainer.querySelector(
      '.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) .selling-plan-item__recurring',
    );
  }

  get sellingPlanOneTime() {
    return this.sellingPlansWidgetContainer.querySelector(
      '.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) .selling-plan-item__one-time',
    );
  }

  get priceElement() {
    if (this.isPreview) return null;
    return this.shopifySection?.querySelector('.block-price__regular') ?? null;
  }

  get comparedAtPrice() {
    if (this.isPreview) return null;
    return this.shopifySection?.querySelector('.block-price__sale') ?? null;
  }

  get visibleSellingPlanForm() {
    const vid = this.variantIdInput?.value;
    if (!vid) return null;
    return this.sellingPlansWidgetContainer.querySelector(`section[data-variant-id="${vid}"]`);
  }

  get isVariantAvailable() {
    return this.selectedPurchaseOption?.getAttributeNames().includes('disabled') ?? false;
  }

  get sellingPlanInput() {
    return this.shopifySection?.querySelector('.selected-selling-plan-id') ?? null;
  }

  get addToCartForms() {
    return this.shopifySection ? Array.from(this.shopifySection.querySelectorAll('[action*="/cart/add"]')) : [];
  }

  appendSellingPlanInputs() {
    const master = this.sellingPlanInput;
    if (!master) return;

    this.addToCartForms.forEach((addToCartForm) => {
      addToCartForm.appendChild(master.cloneNode());
    });
  }

  showSellingPlanForm(sellingPlanFormForSelectedVariant) {
    sellingPlanFormForSelectedVariant?.classList?.remove(hiddenClass);
  }

  hideSellingPlanForms(sellingPlanFormsForUnselectedVariants) {
    sellingPlanFormsForUnselectedVariants.forEach((element) => {
      element.classList.add(hiddenClass);
    });
  }

  handleSellingPlanFormVisibility() {
    const vid = this.variantIdInput?.value;
    if (!vid) return;

    const sellingPlanFormForSelectedVariant = this.sellingPlansWidgetContainer.querySelector(
      `section[data-variant-id="${vid}"]`,
    );
    const sellingPlanFormsForUnselectedVariants = this.sellingPlansWidgetContainer.querySelectorAll(
      `.selling_plan_theme_integration:not([data-variant-id="${vid}"])`,
    );
    this.showSellingPlanForm(sellingPlanFormForSelectedVariant);
    this.hideSellingPlanForms(sellingPlanFormsForUnselectedVariants);
  }

  handleVariantChange() {
    this.handleSellingPlanFormVisibility();
    this.updateSellingPlanInputsValues();
    this.listenToSellingPlanFormRadioButtonChange();
  }

  listenToVariantChange() {
    if (this.isPreview || !this.variantIdInput) return;

    this.listenToAddToCartForms();

    if (this.variantIdInput.tagName === 'INPUT') {
      const variantIdObserver = new MutationObserver((mutationList) => {
        mutationList.forEach((mutationRecord) => {
          this.handleVariantChange(mutationRecord.target.value);
        });
      });

      variantIdObserver.observe(this.variantIdInput, {
        attributes: true,
      });
    }
  }

  listenToAddToCartForms() {
    this.addToCartForms.forEach((addToCartForm) => {
      addToCartForm.addEventListener('change', () => {
        this.handleVariantChange();
      });
    });
  }

  get regularPriceElement() {
    if (this.isPreview) return null;
    return this.shopifySection?.querySelector('.block-price__regular') ?? null;
  }

  get salePriceElement() {
    if (this.isPreview) return null;
    return this.shopifySection?.querySelector('.block-price__sale') ?? null;
  }

  get salePriceValue() {
    return this.salePriceElement?.querySelector('.product-price__sale') ?? null;
  }

  get regularPriceValue() {
    return this.salePriceElement?.querySelector('.product-price__regular') ?? null;
  }

  get sellingPlanAllocationPrice() {
    const groupId = this.selectedPurchaseOption?.dataset?.sellingPlanGroupId;
    if (!groupId) return null;
    return document.getElementById(`${groupId}_allocation_price`);
  }

  get selectedPurchaseOptionPrice() {
    return this.selectedPurchaseOption?.dataset?.variantPrice;
  }

  get selectedPurchaseOptionComparedAtPrice() {
    return this.selectedPurchaseOption?.dataset?.variantCompareAtPrice;
  }

  updatePrice() {
    if (this.isPreview) return;

    const selected = this.selectedPurchaseOption;
    if (!selected || !this.priceElement || !this.regularPriceElement || !this.salePriceElement) return;

    if (
      !this.selectedPurchaseOptionComparedAtPrice ||
      this.selectedPurchaseOptionComparedAtPrice === this.selectedPurchaseOptionPrice
    ) {
      this.showRegularPrice();
      this.hideSalePrice();
      this.priceElement.classList.remove('price--on-sale');
    } else {
      this.showSalePrice();
      this.hideRegularPrice();
      this.priceElement.classList.add('price--on-sale');
    }
  }

  hideSalePrice() {
    if (this.salePriceElement) this.salePriceElement.style.display = 'none';
  }

  hideRegularPrice() {
    if (this.regularPriceElement) this.regularPriceElement.style.display = 'none';
  }

  showRegularPrice() {
    if (this.regularPriceElement) this.regularPriceElement.style.display = 'block';
    const saleEl = this.shopifySection?.querySelector('.price__sale');
    if (saleEl) saleEl.style.display = 'none';
  }

  showSalePrice() {
    if (!this.salePriceElement || !this.salePriceValue || !this.regularPriceValue) return;
    this.salePriceElement.style.display = 'block';
    this.salePriceValue.innerHTML = this.selectedPurchaseOptionComparedAtPrice;
    this.regularPriceValue.innerHTML = this.selectedPurchaseOptionPrice;
  }

  get sellingPlanInputs() {
    return this.shopifySection?.querySelectorAll('.selected-selling-plan-id') ?? [];
  }

  updateSellingPlanInputsValues() {
    if (this.isPreview) return;

    this.sellingPlanInputs.forEach((sellingPlanInput) => {
      sellingPlanInput.value = this.sellingPlanInputValue ?? '';
    });
  }

  get sellingPlanInputValue() {
    return this.selectedPurchaseOption?.dataset?.sellingPlanId ?? '';
  }

  get selectedPurchaseOption() {
    return this.visibleSellingPlanForm?.querySelector('input[type="radio"]:checked') ?? null;
  }

  set selectedPurchaseOption(selectedPurchaseOption) {
    this._selectedPurchaseOption = selectedPurchaseOption;
    if (!this._selectedPurchaseOption) return;

    const oneTime = this.sellingPlanOneTime;
    const recurring = this.sellingPlanRecurring;
    if (!oneTime || !recurring) return;

    if (this._selectedPurchaseOption.dataset.radioType === 'one_time_purchase') {
      oneTime.classList.add('selling-plan-item__active');
      recurring.classList.remove('selling-plan-item__active');
    }
    if (this._selectedPurchaseOption.dataset.radioType === 'selling_plan') {
      oneTime.classList.remove('selling-plan-item__active');
      recurring.classList.add('selling-plan-item__active');
    }
  }

  handleRadioButtonChange(selectedPurchaseOption) {
    this.selectedPurchaseOption = selectedPurchaseOption;
    this.updateSellingPlanInputsValues();
    this.updatePrice();
  }

  listenToSellingPlanFormRadioButtonChange() {
    this.visibleSellingPlanForm?.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', (event) => {
        this.handleRadioButtonChange(event.target);
      });
    });
  }

  enablePerformanceObserver() {
    const performanceObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.initiatorType !== 'fetch') return;

        const url = new URL(entry.name);
        if (url.search.includes('variant') || url.search.includes('variants')) {
          this.updatePrice();
        }
      });
    });

    performanceObserver.observe({ entryTypes: ['resource'] });
  }
}

document.querySelectorAll('.selling_plan_app_container').forEach((sellingPlansWidgetContainer) => {
  new SellingPlansWidget(sellingPlansWidgetContainer);
});
